let routes = [{
		path: '/',
		name: 'layout',
		redirect: {
			name: 'index'
		},
		component: 'layout',
		children: [{
				meta:{title:'后台首页'},
				component: 'index/index'
			},
			
			{
				meta:{title:'相册管理'},
				component: 'image/index'
			},
			{
				meta:{title:'基础设置'},
				component: 'set/base/index'
			},
			{
				meta:{title:'角色管理'},
				component: 'set/manager/index'
			},
			{
				meta:{title:'添加角色'},
				component: 'set/manager/rule'
			},
			
			{
				meta:{title:'管理员列表'},
				component: 'set/admin/index'
			},
			{
				meta:{title:'页面管理'},
				component: 'set/page/index'
			},
			
			
			{
				meta:{title:'当前在线用户'},
				component: 'user/list'
			},
			
			
			
			{
				meta:{title:'在线主播'},
				component: 'data/host'
			},
			{
				meta:{title:'主播列表'},
				component: 'data/hostlist'
			},
			{
				meta:{title:'打点数据'},
				component: 'data/dadian'
			},
			{
				meta:{title:'打点名称'},
				component: 'data/dadiankey'
			},
			{
				meta:{title:'错误日志'},
				component: 'data/error'
			},
			{
				meta:{title:'聊天记录'},
				component: 'data/chat'
			},
			{
				meta:{title:'用户详情'},
				component: 'data/userinfo'
			},
			{
				meta:{title:'主播赛事'},
				component: 'data/hostup'
			},
			{
				meta:{title:'日活统计'},
				component: 'data/day'
			},
			{
				meta:{title:'IM日活统计'},
				component: 'data/imday'
			},
			{
				meta:{title:'访问来源'},
				component: 'data/url'
			},
			{
				meta:{title:'实时在线'},
				component: 'data/hour'
			},
			{
				meta:{title:'用户留存'},
				component: 'data/retained'
			},	
			{
				meta:{title:'邀请查询'},
				component: 'data/code'
			},	
			{
				meta:{title:'404错误'},
				component: 'error/404'
			}
			
		]
	},
	{
		// path:'/login',
		// name:'login',
		//component:()=>import('../../views/login/index.vue')
		meta:{title:'登录页'},
		component: 'login/index'
	},
	{
		path: '*',
		redirect: {
			name: 'index'
		}
	}
]
// 获取路由信息方法
let getRoutes = function() {
	// 生成路由详细信息
	createRoute(routes)
	return routes
}
// 自动生成路由
function createRoute(arr) {
	for (let i = 0; i < arr.length; i++) {
		if (!arr[i].component) return
		// 去除index
		let val = getValue(arr[i].component)
		// 生成name
		arr[i].name = arr[i].name || val.replace(/\//g, '_')
		// 生成apth
		arr[i].path = arr[i].path || `/${val}`
		// 自动生成component
		let componentFun = import(`../../views/${arr[i].component}.vue`)
		arr[i].component = () => componentFun
		if (arr[i].children && arr[i].children.length > 0) {
			createRoute(arr[i].children)
		}
	}
}
// 去除index
function getValue(str) {
	// str = login/index
	// 获取最后一个/索引
	let index = str.lastIndexOf('/')
	// 获取最后一个/后面的值
	let val = str.substring(index + 1, str.length)
	// 判断是不是index结尾
	if (val === 'index') {
		return str.substring(index, -1)
	}
	return str
}
export default getRoutes()
